import { useEffect } from 'react';

const upsert = (tag, selector, attrs) => {
  let node = document.head.querySelector(selector);
  if (!node) {
    node = document.createElement(tag);
    document.head.appendChild(node);
  }
  Object.entries(attrs).forEach(([k, v]) => node.setAttribute(k, v));
};

export const SEO = ({ title, description, path = '/', image, type = 'website', jsonLd, noindex = false, extraMeta = [] }) => {
  useEffect(() => {
    const origin = window.location.origin;
    const url = `${origin}${path}`;
    const img = image
      ? (image.startsWith('http') ? image : `${origin}${image}`)
      : `${origin}/og-cover.jpg`;
    document.title = title;
    upsert('meta', 'meta[name="description"]', { name: 'description', content: description });
    upsert('meta', 'meta[name="robots"]', { name: 'robots', content: noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large' });
    upsert('link', 'link[rel="canonical"]', { rel: 'canonical', href: url });
    upsert('meta', 'meta[property="og:title"]', { property: 'og:title', content: title });
    upsert('meta', 'meta[property="og:description"]', { property: 'og:description', content: description });
    upsert('meta', 'meta[property="og:url"]', { property: 'og:url', content: url });
    upsert('meta', 'meta[property="og:type"]', { property: 'og:type', content: type });
    upsert('meta', 'meta[property="og:image"]', { property: 'og:image', content: img });
    upsert('meta', 'meta[property="og:locale"]', { property: 'og:locale', content: 'fr_FR' });
    upsert('meta', 'meta[property="og:site_name"]', { property: 'og:site_name', content: 'TerraFungi' });
    upsert('meta', 'meta[name="twitter:card"]', { name: 'twitter:card', content: 'summary_large_image' });
    upsert('meta', 'meta[name="twitter:title"]', { name: 'twitter:title', content: title });
    upsert('meta', 'meta[name="twitter:description"]', { name: 'twitter:description', content: description });
    upsert('meta', 'meta[name="twitter:image"]', { name: 'twitter:image', content: img });

    // Balises dynamiques additionnelles (ex. og:product) — nettoyées puis réinjectées à chaque page
    document.head.querySelectorAll('meta[data-seo-extra]').forEach((n) => n.remove());
    (extraMeta || []).forEach(({ property, name, content }) => {
      if (!content) return;
      const node = document.createElement('meta');
      if (property) node.setAttribute('property', property);
      if (name) node.setAttribute('name', name);
      node.setAttribute('content', content);
      node.setAttribute('data-seo-extra', 'true');
      document.head.appendChild(node);
    });

    let ld = document.getElementById('seo-jsonld');
    if (jsonLd) {
      if (!ld) {
        ld = document.createElement('script');
        ld.type = 'application/ld+json';
        ld.id = 'seo-jsonld';
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) {
      ld.remove();
    }
  }, [title, description, path, image, type, noindex, JSON.stringify(jsonLd), JSON.stringify(extraMeta)]);
  return null;
};

export default SEO;
